import React from 'react';

const Crime = () => {
  return (
    <iframe
      src="https://iframe.krgsc.kz/crime"
      title="crime"
      style={{ border: 'none' }}
      width="100%"
      height="100%"
    />
  );
};

export default Crime;
